<template>
  <v-container fluid class="pt-3" v-if="product!=null">
    <vue-headful :title="`รายละเอียดสินค้า - Halal Delivery`" />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>สินค้า</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/view/shop/'+product.shop.ref_no }">{{product.shop.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>

    <section class="mt-4">
      <el-tabs :tab-position="`top`">
        <el-tab-pane label="ข้อมูลทั่วไป">
          <v-layout>
            <v-flex xs12 md8>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="font-weight-bold">ข้อมูลสินค้า</span>
                  <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    v-if="!editDetail"
                    @click="editDetail=true"
                  >แก้ไข</el-button>
                </div>
                <v-layout>
                  <v-flex xs12>
                    <el-form :label-position="`top`" label-width="100px" size="mini">
                      <el-form-item label="สถานะ">
                        <el-select v-model="product.status" placeholder="เลือก">
                          <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="ประเภท">
                        <el-col :span="19">
                          <el-radio-group v-model="product.product_type">
                            <el-radio :label="`a_la_carte`">อาหารจานเดียว</el-radio>
                            <el-radio :label="`customise`">อาหารที่มีตัวเลือก</el-radio>
                            <el-radio :label="`product`">สินค้าอีคอมเมิร์ซ</el-radio>
                            <el-radio :label="`coupon`" :disabled="true">คูปอง/บัตรกำนัล</el-radio>
                            <el-radio :label="`free_item`">ของแถม</el-radio>
                          </el-radio-group>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="ชื่อสินค้า">
                        <el-input v-model="product.name"></el-input>
                      </el-form-item>
                      <el-form-item label="คำอธิบาย">
                        <el-input v-model="product.excerpt"></el-input>
                      </el-form-item>
                      <el-form-item label="รายละเอียด">
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4}"
                          v-model="product.description"
                        ></el-input>
                      </el-form-item>
                      <el-row>
                        <el-col :span="11">
                          <el-form-item label="ราคาขาย (บาท)">
                            <el-input v-model="product.regular_price" type="number"></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11">
                          <!--
                          <el-form-item label="COG (THB)">
                            <el-input v-model="product.cog" type="number"></el-input>
                          </el-form-item>
                          -->
                        </el-col>
                      </el-row>
                      <!--
                      <el-form-item label="Special Price (THB)">
                        <el-col :span="3">
                          <el-switch v-model="enableSpecialPrice"></el-switch>
                        </el-col>
                        <el-col :span="9">
                          <el-input
                            type="number"
                            v-model="product.special_price"
                            :disabled="!enableSpecialPrice"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                      -->
                      <v-divider class="my-4"></v-divider>
                      <el-form-item size="mini" class="mt-3">
                        <el-button type="danger" @click="onProductDetailSubmit">บันทึก</el-button>
                      </el-form-item>
                    </el-form>
                  </v-flex>
                </v-layout>
              </el-card>
            </v-flex>
            <v-flex xs12 md4 class="pl-2">
              <el-form>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">หมวดหมู่สินค้า</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="categoryDialog=true"
                    >เพิ่ม</el-button>
                  </div>
                  <v-layout wrap column>
                    <v-flex
                      class="my-2"
                      xs12
                      v-for="(item, index) in categoryList"
                      v-bind:key="index"
                    >
                      <el-radio
                        v-model="product.groups[0].id"
                        :label="item.product_cate_id"
                      >{{item.name}}</el-radio>
                    </v-flex>
                  </v-layout>
                  <v-divider class="my-4"></v-divider>
                  <el-form-item size="mini" class="mt-3">
                    <el-button type="danger" @click="onProductCategorySubmit">บันทึก</el-button>
                  </el-form-item>
                </el-card>
                <create-category
                  :dialog="categoryDialog"
                  :product="product"
                  @close="categoryDialog=false"
                  @save="loadCategories"
                ></create-category>
              </el-form>

              <el-card class="mt-4 box-card">
                <div slot="header" class="clearfix">
                  <span class="font-weight-bold">Image</span>
                </div>
                <div class="text-xs-center mb-3">
                  <img :src="product.image" style="width:50%" />
                </div>
                <picture-input
                  ref="pictureInput"
                  width="150"
                  height="150"
                  margin="0"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="btn"
                  :custom-strings="{
                            upload: '<h1>Upload Picture!</h1>',
                            drag: 'อัพโหลดรูปที่นี่'
                          }"
                  @change="onImageChanged"
                ></picture-input>
              </el-card>
            </v-flex>
          </v-layout>
        </el-tab-pane>
        <el-tab-pane label="การปรับแต่ง">
          <template v-if="product.product_type=='customise'">
            <v-layout>
              <v-flex xs12 sm4 md4>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">Pick customise Template</span>
                  </div>
                  <v-layout>
                    <v-flex xs12>
                      <ul class="hlz-list">
                        <li @click="onTemplateClicked('c1fm')">
                          Choose
                          <strong>1</strong> from x choices.
                        </li>
                        <li @click="onTemplateClicked('cmfm')">
                          Choose
                          <strong>many</strong> from x choices
                        </li>
                      </ul>

                      <div class="mt-4">
                        <div>
                          <el-button
                            style="width:100%;"
                            type="text"
                            @click="customiseDialog=true"
                          >Test Customise</el-button>
                        </div>
                        <div class="mt-3">
                          <el-button
                            style="width:100%;"
                            type="primary"
                            @click="onCustomiseUpdated"
                          >Update Customise</el-button>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </el-card>
              </v-flex>
              <v-flex xs12 sm8 md8 class="pl-4">
                <!-- START SUBJECT -->
                <customise-subject
                  :subject="subject"
                  v-for="(subject, i) in customise_json"
                  v-bind:key="i"
                  @remove="onRemoveSubject(i)"
                ></customise-subject>
                <!-- END SUBJECT -->
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <div
              class="pa-3 text-xs-center"
            >Please change product type to "Customise" on General Tab to Start customise this product.</div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="ประวัติการขาย"></el-tab-pane>
      </el-tabs>
    </section>

    <customise-dialog
      :customise_json="customise_json"
      :dialog="customiseDialog"
      @done="onCustomiseProductClosed"
      @close="onCustomiseProductClosed"
    ></customise-dialog>

    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import Service from "../../services";
import CustomiseSubject from "../../components/CustomiseSubject";
import CustomiseDialog from "../../components/CustomiseDialog";
import CreateCategory from "../../components/product/CreateCategory";
import PictureInput from "vue-picture-input";

export default {
  components: {
    CustomiseSubject,
    CustomiseDialog,
    CreateCategory,
    PictureInput
  },
  props: ["product_id"],
  data() {
    return {
      loadingDialog: false,
      customiseDialog: false,
      categoryDialog: false,
      product: null,
      statusList: [
        { label: "ยังไม่เรียบร้อย", value: "draft" },
        { label: "ไม่พร้อมขาย", value: "inactive" },
        { label: "ขายหมด", value: "soldout" },
        { label: "ใช้งานอยู่", value: "published" }
      ],
      editDetail: false,
      enableSpecialPrice: false,
      title: "",
      customise_json: [],
      categoryList: []
    };
  },
  created() {
    Service.Product.get(this.product_id).then(res => {
      if (res.success) {
        this.product = res.data;
        this.title = this.product.name;
        if (this.product.modifiers != null) {
          this.customise_json = this.product.modifiers;
        }
        this.loadCategories();
      }
    });
  },
  methods: {
    loadCategories() {
      Service.Shop.getCategories(this.product.shop_id).then(res => {
        if (res.success) {
          this.categoryList = res.data;
        }
        console.log(this.categoryList);
      });
      this.categoryDialog = false;
    },
    onProductDetailSubmit() {
      this.loadingDialog = true;
      let data = {
        product_id: this.product.product_id,
        status: this.product.status,
        product_type: this.product.product_type,
        product_name: this.product.name,
        product_excerpt: this.product.excerpt,
        product_description: this.product.description,
        regular_price: this.product.regular_price
      };

      if (this.enableSpecialPrice && this.product.special_price != null) {
        data = { ...data, special_price: this.product.special_price };
      }

      Service.Product.update(data).then(res => {
        this.loadingDialog = false;
      });
    },
    onProductCategorySubmit() {
      this.loadingDialog = true;
      let data = {
        product_id: this.product.product_id,
        shop_id: this.product.shop_id,
        product_cate_id: this.product.groups[0].id
      };

      Service.Product.update(data).then(res => {
        this.loadingDialog = false;
      });
    },
    onImageChanged(image) {
      if (image) {
        let data = {
          image: image,
          product_id: this.product.product_id
        };
        Service.Product.upload(data);
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },
    onTemplateClicked(template) {
      let id = "s" + moment().format("X");
      let c1fm = {
        title: "Unamed",
        items: [
          {
            id: 111,
            name: "Item A",
            price: 0,
            cog: 0
          },
          {
            id: 112,
            name: "Item B",
            price: 20,
            cog: 0
          }
        ],
        required: true,
        duplicate: false,
        min: 1,
        max: 2,
        imageSize: "none",
        isValid: false
      };
      let cmfm = {
        title: "Unamed",
        items: [
          {
            id: 113,
            name: "Item D",
            price: 0,
            cog: 0
          },
          {
            id: 114,
            name: "Item F",
            price: 20,
            cog: 0
          }
        ],
        required: true,
        duplicate: true,
        min: 1,
        max: 5,
        imageSize: "small",
        isValid: false
      };
      if (template == "c1fm") {
        this.customise_json.push({ id: id, ...c1fm });
      } else if (template == "cmfm") {
        this.customise_json.push({ id: id, ...cmfm });
      }
    },
    onRemoveSubject(index) {
      this.customise_json.splice(index, 1);
    },
    onCustomiseProductClosed() {
      this.customiseDialog = false;
    },
    onCustomiseUpdated() {
      console.log(this.customise_json);
      //* RESET PRE SELECTED */
      this.customise_json = this.customise_json.map((subject, x) => {
        if (subject.duplicate) {
          this.customise_json[x].items = subject.items.map((item, y) => {
            return { ...item, quantity: 0 };
          });
        } else {
          this.customise_json[x].items = subject.items.map((item, y) => {
            return { ...item, checked: false };
          });
        }
        return { ...subject, isValid: false };
      });
      console.log(this.customise_json);

      let data = {
        product_id: this.product_id,
        modifiers: JSON.stringify(this.customise_json)
      };

      Service.Product.update(data).then(res => {
        console.log(res);
      });
    }
  }
};
</script>
